import styled from "styled-components";

export const DaySelectStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 2px 0 #00000008;
  background: white;
  border-radius: 4px;
  border: 1px solid #dfdddd;
  box-sizing: border-box;
  transition: all 300ms ease-out !important;
  position: relative;
  cursor: pointer;
  .main {
    .drop-down-container {
      .drop-down-header {
        justify-content: end !important;
        .chevron {
          transition: 0.2s ease;
          margin-right: 15px;
        }
        .chevron-rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  .drop-down-list-container {
    box-shadow: 0 5px 25px 0 #0000001a;
    margin-top: 0.5rem;
    width: 100%;
    transition: 0.4s ease;
    position: absolute;
    right: 0;
    top: 40px;
    z-index: 1000;
    background: white;
    .drop-down-list {
      min-width: 100%;
      max-height: 15rem;
      overflow-y: auto;
      width: max-content;
      cursor: pointer;
      .list-item {
        transition: 0.4s ease;
        font-size: 14px;
        padding: 0.5rem 1rem;
        min-width: 100%;
        color: #41434d;
      }
      .list-item-other {
        padding-left: 30px;
      }
    }
  }
  .day-btn-wrapper {
    width: 50%;
    margin-left: auto;
    padding: 0 8px 8px 0;
    @media (max-width: 700px) {
      width: 100%;
    }
  }
  .label {
    white-space: nowrap;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    outline: none;
    font-size: 15px;
    padding: 10px 0 10px 15px;
    color: #41434d;
    font-size: 16px;
  }
  .value {
    color: #41434d;
  }
`;
export const StyledInput = styled.input<any>`
  border-radius: 12px;
  border: 1.5px solid #dfe3f6;
  box-sizing: border-box;
  padding: 9.7px 15px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  outline: none;
  transition: all 300ms ease-out !important;
  width: 100%;
  color: #41434d !important;
  &:hover {
    border-color: #669dff !important;
  }
  &:focus {
    border-color: #669dff !important;
    //box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
  }

  &:focus {
    box-shadow: none;
    color: #8b90a5;
    border-color: #edf1ff;
  }
  &::placeholder {
  }
`;
